/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateOfBirthHistoryEntry
 */
export interface DateOfBirthHistoryEntry {
    /**
     * Previous value, unix ms. Absent when none was set.
     * @type {number}
     * @memberof DateOfBirthHistoryEntry
     */
    from?: number;
    /**
     * New value, unix ms. Absent when the date was cleared.
     * @type {number}
     * @memberof DateOfBirthHistoryEntry
     */
    to?: number;
    /**
     * 
     * @type {string}
     * @memberof DateOfBirthHistoryEntry
     */
    by: string;
    /**
     * 
     * @type {number}
     * @memberof DateOfBirthHistoryEntry
     */
    at: number;
    /**
     * 
     * @type {string}
     * @memberof DateOfBirthHistoryEntry
     */
    reason: string;
}

/**
 * Check if a given object implements the DateOfBirthHistoryEntry interface.
 */
export function instanceOfDateOfBirthHistoryEntry(value: object): value is DateOfBirthHistoryEntry {
    if (!('by' in value) || value['by'] === undefined) return false;
    if (!('at' in value) || value['at'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DateOfBirthHistoryEntryFromJSON(json: any): DateOfBirthHistoryEntry {
    return DateOfBirthHistoryEntryFromJSONTyped(json, false);
}

export function DateOfBirthHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateOfBirthHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'] == null ? undefined : json['from'],
        'to': json['to'] == null ? undefined : json['to'],
        'by': json['by'],
        'at': json['at'],
        'reason': json['reason'],
    };
}

export function DateOfBirthHistoryEntryToJSON(json: any): DateOfBirthHistoryEntry {
    return DateOfBirthHistoryEntryToJSONTyped(json, false);
}

export function DateOfBirthHistoryEntryToJSONTyped(value?: DateOfBirthHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
        'by': value['by'],
        'at': value['at'],
        'reason': value['reason'],
    };
}

